import noop from 'utils/noop';
import { useDispatch, useSelector } from 'react-redux';
import { selectOrganizationId } from 'core/userContext';
import { FormField } from 'ui/formField';
import { FlexSpacer } from 'ui/flexSpacer';
import { TextArea } from 'ui/inputs/textArea';
import { PrimaryButton, SecondaryButton } from 'ui/button';
import styled from 'styled-components';
import { spacing } from 'ui/theme';

import { editDeepLinkPathRequest, upsertAndroidAssetLinksRequest } from '../actions';
import { useValidJson } from '../hooks';

const ButtonContainer = styled.div`
  margin-top: ${spacing.half};
`;

const TEXT = {
  errorMessage: 'File must be formatted as a JSON object',
  submitCTA: 'Save changes',
  cancelCTA: 'Cancel',
};

// type PathFormProps = {
//   appDomain: string,
//   domain: string,
//   jsonString: string,
//   onClose: () => void,
//   platform: 'apple' | 'android',
// };

export const PathForm = ({
  appDomain = '',
  domain = '',
  jsonString = '',
  onClose = noop,
  platform = 'apple',
}) => {
  const dispatch = useDispatch();
  const organizationId = useSelector(selectOrganizationId);
  const [json, setJson, hasErrorMessage] = useValidJson(jsonString);
  const onSubmit = (e) => {
    e.preventDefault();
    if (platform === 'apple') {
      // backend function for uploading the AASA takes a string representation of the JSON object
      return dispatch(editDeepLinkPathRequest(appDomain, domain, organizationId, json));
    }

    // the backend function for uploading android asset jsons
    // requires the data to be the actual JSON object,
    // rather than a string representation.
    const parsedJson = JSON.parse(json);
    return dispatch(upsertAndroidAssetLinksRequest(parsedJson, domain, organizationId));
  };

  const isDisabled = json.length === 0 || hasErrorMessage;

  return (
    <form data-test="mailDomains-path-form" onSubmit={onSubmit}>
      <FormField
        hasError={!!hasErrorMessage}
        errorText={TEXT.errorMessage}
        inputId="mailDomains-pathJson"
      >
        <TextArea
          autoFocus
          data-test="mailDomains-path-form-json-input"
          hasError={!!hasErrorMessage}
          id="mailDomains-pathJson"
          onChange={(value) => setJson(value)}
          rows={15}
          value={json}
        />
      </FormField>
      <ButtonContainer data-id="what">
        <FlexSpacer justifyContent="flex-end" alignItems="center">
          <SecondaryButton data-test="mailDomains-path-form-cancel-button" onClick={onClose}>
            {TEXT.cancelCTA}
          </SecondaryButton>
          <PrimaryButton
            data-test="mailDomains-path-form-submit-button"
            isDisabled={isDisabled}
            type="submit"
          >
            {TEXT.submitCTA}
          </PrimaryButton>
        </FlexSpacer>
      </ButtonContainer>
    </form>
  );
};
